module.exports = __webpack_public_path__ + "img/zizhi6.f9b921e7.jpg";